export function horizontalRuleNodeSpec() {
    return {
        horizontal_rule: {
            group: "block",
            parseDOM: [{ tag: "hr" }],
            selectable: false,
            toDOM() {
                return ["hr"];
            },
        },
    };
}
